var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M15.811 14.93c-.92-.91-3.07-3.06-4.3-4.28A6.5 6.5 0 0 0 13 6.5a6.5 6.5 0 0 0-6.5-6.5 6.5 6.5 0 1 0 0 13c1.57 0 3-.55 4.12-1.47 1.05 1.05 3.05 3.03 4.32 4.29.12.12.28.18.44.18s.32-.06.44-.18a.63.63 0 0 0-.01-.89m-9.31-3.18c-2.89 0-5.25-2.35-5.25-5.25 0-2.89 2.36-5.25 5.25-5.25s5.25 2.36 5.25 5.25c0 2.9-2.36 5.25-5.25 5.25"
  })));
};
export default SvgSearchIcon;